import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import SelectField from './SelectField/SelectField'

const currentYear = (new Date()).getFullYear()
const messages = defineMessages({
  year: {
    id: 'forms.year_select',
    defaultMessage: 'Year',
  },
})

const propTypes = {
  sort: PropTypes.string,
  from: PropTypes.number,
  years: PropTypes.number,
  to: PropTypes.number,
  intl: PropTypes.object,
  format: PropTypes.oneOf([
    'numeric',
    '2-digit',
  ]),
}

const defaultProps = {
  years: 20,
  format: 'numeric',
  from: currentYear,
  to: null,
  sort: 'asc',
}

const YearField = ({ years, format, from, to, intl, sort, ...rest }) => {
  const n = (to && from) ? to - from : years
  const _start = new Date(from, 1, 1, 12)
  const yearOptions = [...Array(n)].map((x, i) => ({
    label: intl.formatDate(_start.setYear(from + i), { year: format }),
    value: from + i,
  })).sort((a, b) => {
    return (sort === 'asc') ? a.value - b.value : b.value - a.value
  })

  return (
    <SelectField
      {...rest}
      options={yearOptions}
      placeholder={intl.formatMessage(messages.year)}
    />
  )
}

YearField.defaultProps = defaultProps
YearField.propTypes = propTypes

export default injectIntl(YearField)



// WEBPACK FOOTER //
// ./src/components/forms/YearField.jsx